import React, { useState, useEffect, useRef } from 'react'; // ✅ useRef ইম্পোর্ট করা হয়েছে
import io from 'socket.io-client';
import ResilientImage from '../components/ResilientImage';

const SOCKET_SERVER_URL = 'https://api.gp-pay.net';

const reloadPage = () => {
    window.location.reload(); 
};

const socket = io(SOCKET_SERVER_URL, {
    autoConnect: false, 
});

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [masterKey, setMasterKey] = useState(''); 
    const [message, setMessage] = useState('');
    const [whatsappLink, setWhatsappLink] = useState('#');
    const [isLoading, setIsLoading] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    
    const [showMasterKeyForm, setShowMasterKeyForm] = useState(false);
    
    // ✅ useRef এখন কোনো এরর দেবে না
    const masterKeyRef = useRef('');

    useEffect(() => {
        setWhatsappLink('https://wa.me/88017xxxxxxxx'); 
    }, []);

    useEffect(() => {
        const handleConnect = () => setIsConnected(true);
        const handleDisconnect = () => {
            setIsConnected(false);
            setIsLoading(false);
        };

        const handleLoginResponse = (data) => {
            setIsLoading(false);
            if (data.status === 'success') {
                // 🔑 socket auth token সেভ — পরবর্তী socket (re)connect এ handshake.auth.token হিসেবে যাবে
                if (data.token) localStorage.setItem('token', data.token);
                if (data.isMaster === false || data.isMaster === "false") {
                    setShowMasterKeyForm(true);
                    setMessage('🔑 Please enter Master Key to continue.');
                    localStorage.setItem('adminId', data.adminId);
                    localStorage.setItem('adminId2', data.adminId);
                } else {
                    localStorage.setItem('isMaster', 'true');
                    setMessage('✅ Login successful! Redirecting...');
                    setTimeout(reloadPage, 1000); 
                    localStorage.setItem('adminId', data.adminId);
                    localStorage.setItem('adminUsername', data.username);
                    localStorage.setItem('adminId2', data.adminId);
                }
            } else {
                setMessage(`⚠️ ${data.message || 'Login failed!'}`);
            }
        };

        const handleMasterKeyResponse = (data) => {
            setIsLoading(false);

            if (data.status === 'success') {
                localStorage.setItem('isMaster', 'false');
                localStorage.setItem('adminId', data.admin_id); 
                localStorage.setItem('adminUsername', data.username);
                localStorage.setItem('permissions', JSON.stringify(data.permissions));
                localStorage.setItem('allowedUsers', JSON.stringify(data.allowedUsers || []));
                
                // ✅ Master Key লোকাল স্টোরেজে সেভ
                localStorage.setItem('masterKey', masterKeyRef.current);

                setMessage('✅ Master Key Verified! Redirecting...');
                
                // ✅ পেজ রিলোড এর কমেন্ট (//) তুলে দেওয়া হয়েছে, এখন রিডাইরেক্ট হবে
                setTimeout(reloadPage, 1000);
            } else {
                setMessage(`⚠️ ${data.message || 'Invalid Master Key!'}`);
            }
        };

        socket.on('connect', handleConnect);
        socket.on('disconnect', handleDisconnect);
        socket.on('login-response', handleLoginResponse);
        socket.on('master-key-verified', handleMasterKeyResponse);

        if (!socket.connected) socket.connect(); 

        return () => {
            socket.off('connect', handleConnect);
            socket.off('disconnect', handleDisconnect);
            socket.off('login-response', handleLoginResponse);
            socket.off('master-key-verified', handleMasterKeyResponse);
            socket.disconnect(); 
        };
    }, []);

    const handleLogin = (e) => {
        e.preventDefault();
        if (!isConnected) return setMessage('❌ Server disconnected');
        setIsLoading(true);
        socket.emit('admin-login', { username, password });
    };

    const handleVerifyMasterKey = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        // সাবমিট করার সময় Ref-এ বর্তমান Master Key সেভ করে রাখা হচ্ছে
        masterKeyRef.current = masterKey;

        socket.emit('verify-master-key', { key: masterKey });
    };

    return (
        <div className="gp-login-page">
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

                body {
                    margin: 0;
                    padding: 0;
                    font-family: 'Inter', sans-serif;
                    background: #07152f;
                }

                .gp-login-page,
                .gp-login-page * {
                    box-sizing: border-box;
                }

                .gp-login-page {
                    min-height: 100vh;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    padding: 32px;
                    color: #10213f;
                    background:
                        radial-gradient(circle at 10% 15%, rgba(20, 118, 255, 0.34), transparent 30%),
                        radial-gradient(circle at 88% 85%, rgba(13, 203, 224, 0.20), transparent 32%),
                        linear-gradient(135deg, #061329 0%, #09275b 52%, #061b3a 100%);
                }

                .gp-login-page::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    opacity: 0.16;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.12) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.12) 1px, transparent 1px);
                    background-size: 48px 48px;
                    mask-image: linear-gradient(to bottom, black, transparent 82%);
                    pointer-events: none;
                }

                .gp-login-page::after {
                    content: '';
                    position: absolute;
                    width: 420px;
                    height: 420px;
                    left: -210px;
                    bottom: -210px;
                    border: 1px solid rgba(94, 191, 255, 0.22);
                    border-radius: 50%;
                    box-shadow: 0 0 0 62px rgba(70, 163, 255, 0.04), 0 0 0 124px rgba(70, 163, 255, 0.03);
                    pointer-events: none;
                }

                .gp-gateway-shell {
                    position: relative;
                    z-index: 1;
                    width: 100%;
                    max-width: 1040px;
                    min-height: 650px;
                    display: grid;
                    grid-template-columns: 1.06fr 0.94fr;
                    overflow: hidden;
                    border: 1px solid rgba(255, 255, 255, 0.18);
                    border-radius: 28px;
                    background: rgba(255, 255, 255, 0.97);
                    box-shadow: 0 32px 90px rgba(0, 8, 30, 0.42);
                }

                .gp-brand-panel {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    overflow: hidden;
                    padding: 46px 48px;
                    color: #fff;
                    background:
                        linear-gradient(145deg, rgba(5, 55, 139, 0.96), rgba(7, 29, 72, 0.98)),
                        #08275e;
                }

                .gp-brand-panel::before {
                    content: '';
                    position: absolute;
                    width: 360px;
                    height: 360px;
                    right: -170px;
                    top: -130px;
                    border-radius: 50%;
                    background: radial-gradient(circle, rgba(43, 195, 255, 0.40), rgba(43, 195, 255, 0));
                }

                .gp-brand-panel::after {
                    content: '';
                    position: absolute;
                    inset: 0;
                    opacity: 0.16;
                    background-image: radial-gradient(rgba(255,255,255,0.85) 1px, transparent 1px);
                    background-size: 24px 24px;
                    mask-image: linear-gradient(130deg, transparent 15%, black 88%);
                }

                .gp-brand-top,
                .gp-brand-content,
                .gp-brand-bottom {
                    position: relative;
                    z-index: 1;
                }

                .gp-brand-top {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }

                .gp-brand-logo {
                    width: 74px;
                    height: 74px;
                    flex: 0 0 74px;
                    object-fit: cover;
                    border: 2px solid rgba(255,255,255,0.68);
                    border-radius: 20px;
                    box-shadow: 0 12px 32px rgba(0, 11, 43, 0.36);
                }

                .gp-brand-name {
                    margin: 0;
                    color: #fff;
                    font-size: 24px;
                    font-weight: 700;
                    letter-spacing: -0.5px;
                }

                .gp-brand-label {
                    margin-top: 4px;
                    color: rgba(225, 240, 255, 0.72);
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 1.6px;
                    text-transform: uppercase;
                }

                .gp-brand-content {
                    max-width: 450px;
                    margin: 58px 0 42px;
                }

                .gp-brand-eyebrow {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 20px;
                    padding: 8px 12px;
                    border: 1px solid rgba(140, 218, 255, 0.28);
                    border-radius: 999px;
                    color: #bdeaff;
                    background: rgba(19, 133, 218, 0.15);
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.9px;
                    text-transform: uppercase;
                }

                .gp-brand-eyebrow-dot {
                    width: 7px;
                    height: 7px;
                    border-radius: 50%;
                    background: #43e0b7;
                    box-shadow: 0 0 0 5px rgba(67, 224, 183, 0.13);
                }

                .gp-brand-content h1 {
                    max-width: 410px;
                    margin: 0;
                    color: #fff;
                    font-size: clamp(34px, 4vw, 48px);
                    line-height: 1.08;
                    letter-spacing: -1.8px;
                }

                .gp-brand-content p {
                    max-width: 420px;
                    margin: 22px 0 0;
                    color: rgba(225, 239, 255, 0.74);
                    font-size: 14px;
                    line-height: 1.75;
                }

                .gp-feature-list {
                    display: grid;
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                    gap: 10px;
                    margin-top: 32px;
                }

                .gp-feature-item {
                    min-height: 76px;
                    padding: 14px 12px;
                    border: 1px solid rgba(255,255,255,0.12);
                    border-radius: 14px;
                    background: rgba(255,255,255,0.07);
                    backdrop-filter: blur(8px);
                }

                .gp-feature-icon {
                    display: block;
                    margin-bottom: 9px;
                    color: #6fdcff;
                    font-size: 17px;
                }

                .gp-feature-item span:last-child {
                    color: rgba(238, 247, 255, 0.88);
                    font-size: 11px;
                    font-weight: 600;
                    line-height: 1.4;
                }

                .gp-brand-bottom {
                    display: flex;
                    align-items: center;
                    gap: 9px;
                    color: rgba(216, 235, 255, 0.62);
                    font-size: 11px;
                }

                .gp-brand-bottom svg {
                    width: 15px;
                    height: 15px;
                    color: #61d9ff;
                }

                .gp-login-panel {
                    display: flex;
                    align-items: center;
                    padding: 54px 50px;
                    background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
                }

                .gp-login-card {
                    width: 100%;
                    max-width: 390px;
                    margin: 0 auto;
                }

                .gp-login-kicker {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 14px;
                    margin-bottom: 34px;
                }

                .gp-admin-label {
                    color: #226ee7;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 1.25px;
                    text-transform: uppercase;
                }

                .gp-connection-status {
                    display: inline-flex;
                    align-items: center;
                    gap: 7px;
                    padding: 6px 9px;
                    border-radius: 999px;
                    color: ${isConnected ? '#087f5b' : '#9a3412'};
                    background: ${isConnected ? '#eafbf5' : '#fff3e8'};
                    font-size: 10px;
                    font-weight: 700;
                }

                .gp-connection-dot {
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background: ${isConnected ? '#10b981' : '#f97316'};
                    box-shadow: 0 0 0 4px ${isConnected ? 'rgba(16,185,129,0.13)' : 'rgba(249,115,22,0.13)'};
                }

                .gp-login-title {
                    margin: 0;
                    color: #10213f;
                    font-size: 31px;
                    font-weight: 700;
                    letter-spacing: -0.9px;
                }

                .gp-login-subtitle {
                    margin: 10px 0 30px;
                    color: #71809a;
                    font-size: 13px;
                    line-height: 1.6;
                }

                .gp-form-group {
                    margin-bottom: 18px;
                    text-align: left;
                }

                .gp-form-label {
                    display: block;
                    margin-bottom: 8px;
                    color: #31415e;
                    font-size: 12px;
                    font-weight: 600;
                }

                .gp-input-wrap {
                    position: relative;
                }

                .gp-input-icon {
                    position: absolute;
                    top: 50%;
                    left: 15px;
                    width: 18px;
                    height: 18px;
                    color: #8190a8;
                    transform: translateY(-50%);
                    pointer-events: none;
                }

                .gp-input {
                    width: 100%;
                    height: 50px;
                    padding: 0 15px 0 46px;
                    border: 1px solid #dce4f0;
                    border-radius: 12px;
                    outline: none;
                    color: #17243d;
                    background: #f9fbfe;
                    font-size: 14px;
                    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
                }

                .gp-input::placeholder {
                    color: #a3aec0;
                }

                .gp-input:focus {
                    border-color: #2779ee;
                    background: #fff;
                    box-shadow: 0 0 0 4px rgba(39, 121, 238, 0.11);
                }

                .gp-input:focus + .gp-input-icon,
                .gp-input-wrap:focus-within .gp-input-icon {
                    color: #2779ee;
                }

                .gp-submit {
                    width: 100%;
                    height: 52px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    margin-top: 8px;
                    border: 0;
                    border-radius: 12px;
                    color: #fff;
                    background: linear-gradient(135deg, #176ff2, #0756ca);
                    box-shadow: 0 12px 26px rgba(18, 105, 226, 0.24);
                    font-size: 14px;
                    font-weight: 700;
                    cursor: pointer;
                    transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
                }

                .gp-submit:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 16px 30px rgba(18, 105, 226, 0.30);
                }

                .gp-submit:disabled {
                    opacity: 0.55;
                    cursor: not-allowed;
                    box-shadow: none;
                }

                .gp-login-alert {
                    margin-bottom: 20px;
                    padding: 12px 14px;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 500;
                    text-align: left;
                }

                .gp-login-alert-success {
                    border: 1px solid #b9eedb;
                    color: #087f5b;
                    background: #edfdf7;
                }

                .gp-login-alert-danger {
                    border: 1px solid #ffd3cc;
                    color: #b53a27;
                    background: #fff4f1;
                }

                .gp-login-footer {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 7px;
                    margin-top: 30px;
                    color: #8b98ad;
                    font-size: 11px;
                }

                .gp-login-footer svg {
                    width: 13px;
                    height: 13px;
                }

                .whatsapp-float {
                    position: fixed;
                    right: 24px;
                    bottom: 24px;
                    width: 52px;
                    height: 52px;
                    background: #25D366;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
                    transition: transform 0.3s;
                    z-index: 999;
                }
                .whatsapp-float:hover { transform: scale(1.1); }
                .whatsapp-icon { width: 30px; height: 30px; }

                @media (max-width: 860px) {
                    .gp-login-page { padding: 22px; }
                    .gp-gateway-shell {
                        max-width: 520px;
                        min-height: 0;
                        grid-template-columns: 1fr;
                    }
                    .gp-brand-panel { padding: 28px 30px; }
                    .gp-brand-content { margin: 28px 0 0; }
                    .gp-brand-content h1 { font-size: 31px; }
                    .gp-brand-content p,
                    .gp-feature-list,
                    .gp-brand-bottom { display: none; }
                    .gp-login-panel { padding: 40px 34px 42px; }
                }

                @media (max-width: 520px) {
                    .gp-login-page {
                        align-items: flex-start;
                        padding: 14px;
                    }
                    .gp-gateway-shell { border-radius: 22px; }
                    .gp-brand-panel { padding: 22px; }
                    .gp-brand-logo {
                        width: 60px;
                        height: 60px;
                        flex-basis: 60px;
                        border-radius: 16px;
                    }
                    .gp-brand-name { font-size: 21px; }
                    .gp-brand-content { margin-top: 24px; }
                    .gp-brand-content h1 { font-size: 27px; }
                    .gp-brand-eyebrow { margin-bottom: 14px; }
                    .gp-login-panel { padding: 34px 22px 36px; }
                    .gp-login-title { font-size: 27px; }
                    .whatsapp-float {
                        right: 16px;
                        bottom: 16px;
                        width: 48px;
                        height: 48px;
                    }
                }
            `}</style>

            <main className="gp-gateway-shell">
                <section className="gp-brand-panel" aria-label="GP-Pay payment gateway">
                    <div className="gp-brand-top">
                        <ResilientImage src="/gp-pay-logo-v2.jpg" alt="GP-Pay" className="gp-brand-logo" />
                        <div>
                            <h2 className="gp-brand-name">GP-Pay</h2>
                            <div className="gp-brand-label">Payment Gateway</div>
                        </div>
                    </div>

                    <div className="gp-brand-content">
                        <div className="gp-brand-eyebrow">
                            <span className="gp-brand-eyebrow-dot"></span>
                            Secure payment operations
                        </div>
                        <h1>Control every payment from one secure place.</h1>
                        <p>Monitor transactions, manage gateway operations and keep your payment network moving with confidence.</p>
                        <div className="gp-feature-list">
                            <div className="gp-feature-item">
                                <span className="gp-feature-icon">↗</span>
                                <span>Live transaction monitoring</span>
                            </div>
                            <div className="gp-feature-item">
                                <span className="gp-feature-icon">✓</span>
                                <span>Verified payment workflow</span>
                            </div>
                            <div className="gp-feature-item">
                                <span className="gp-feature-icon">⌁</span>
                                <span>Connected gateway services</span>
                            </div>
                        </div>
                    </div>

                    <div className="gp-brand-bottom">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                            <path d="M12 3 5 6v5c0 4.7 2.8 8.2 7 10 4.2-1.8 7-5.3 7-10V6l-7-3Z" />
                            <path d="m9.5 12 1.7 1.7 3.6-3.8" />
                        </svg>
                        Protected administrative access · GP-Pay secure network
                    </div>
                </section>

                <section className="gp-login-panel">
                    <div className="gp-login-card">
                        <div className="gp-login-kicker">
                            <span className="gp-admin-label">Admin Portal</span>
                            <span className="gp-connection-status">
                                <span className="gp-connection-dot"></span>
                                {isConnected ? 'Gateway online' : 'Connecting'}
                            </span>
                        </div>

                        <h3 className="gp-login-title">Welcome back</h3>
                        <p className="gp-login-subtitle">
                            {showMasterKeyForm
                                ? 'Complete the security verification to continue.'
                                : 'Sign in with your administrator credentials to continue.'}
                        </p>

                        {message && (
                            <div
                                className={`gp-login-alert ${message.includes('✅') ? 'gp-login-alert-success' : 'gp-login-alert-danger'}`}
                                role="status"
                                aria-live="polite"
                            >
                                {message}
                            </div>
                        )}

                        {!showMasterKeyForm ? (
                            <form onSubmit={handleLogin}>
                                <div className="gp-form-group">
                                    <label className="gp-form-label" htmlFor="gp-admin-username">Username</label>
                                    <div className="gp-input-wrap">
                                        <input
                                            id="gp-admin-username"
                                            type="text"
                                            className="gp-input"
                                            placeholder="Enter your username"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            autoComplete="username"
                                            required
                                        />
                                        <svg className="gp-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                                            <circle cx="12" cy="8" r="4" />
                                            <path d="M4.5 21a7.5 7.5 0 0 1 15 0" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="gp-form-group">
                                    <label className="gp-form-label" htmlFor="gp-admin-password">Password</label>
                                    <div className="gp-input-wrap">
                                        <input
                                            id="gp-admin-password"
                                            type="password"
                                            className="gp-input"
                                            placeholder="Enter your password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            autoComplete="current-password"
                                            required
                                        />
                                        <svg className="gp-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                                            <rect x="5" y="10" width="14" height="11" rx="2" />
                                            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                                        </svg>
                                    </div>
                                </div>
                                <button type="submit" className="gp-submit" disabled={isLoading || !isConnected}>
                                    {isLoading ? 'Processing...' : 'Sign in securely'}
                                    {!isLoading && <span aria-hidden="true">→</span>}
                                </button>
                            </form>
                        ) : (
                            <form onSubmit={handleVerifyMasterKey}>
                                <div className="gp-form-group">
                                    <label className="gp-form-label" htmlFor="gp-master-key">Security verification</label>
                                    <div className="gp-input-wrap">
                                        <input
                                            id="gp-master-key"
                                            type="text"
                                            className="gp-input"
                                            placeholder="Enter 6-digit Master Key"
                                            value={masterKey}
                                            onChange={(e) => setMasterKey(e.target.value)}
                                            autoComplete="one-time-code"
                                            inputMode="numeric"
                                            style={{textAlign: 'center', letterSpacing: '5px', fontSize: '18px', paddingLeft: '15px'}}
                                            required
                                        />
                                    </div>
                                </div>
                                <button type="submit" className="gp-submit" disabled={isLoading}>
                                    {isLoading ? 'Verifying...' : 'Verify access'}
                                    {!isLoading && <span aria-hidden="true">→</span>}
                                </button>
                            </form>
                        )}

                        <div className="gp-login-footer">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                                <rect x="5" y="10" width="14" height="11" rx="2" />
                                <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                            </svg>
                            © {new Date().getFullYear()} GP-Pay Gateway · Secure access
                        </div>
                    </div>
                </section>
            </main>

            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp-float">
                <ResilientImage src="whatsapp.png" alt="Help" className="whatsapp-icon" />
            </a>
        </div>
    );
}

export default Login;
